import Keycloak from 'keycloak-js';

export const authEnabled = process.env.REACT_APP_AUTH_ENABLED === 'true';
let client;
let initialization;

export function keycloakClient() {
  if (!authEnabled) return null;
  if (!client) {
    const url = process.env.REACT_APP_KEYCLOAK_URL;
    const realm = process.env.REACT_APP_KEYCLOAK_REALM;
    const clientId = process.env.REACT_APP_KEYCLOAK_CLIENT_ID;
    if (!url || !realm || !clientId) throw new Error('Keycloak configuration is incomplete');
    client = new Keycloak({ url, realm, clientId });
  }
  return client;
}

export function initializeKeycloak(onLoad = 'login-required') {
  const keycloak = keycloakClient();
  if (!keycloak) return Promise.resolve(false);
  if (!initialization) initialization = keycloak.init({ onLoad, pkceMethod: 'S256', checkLoginIframe: false });
  return initialization;
}
